import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import DebouncedNumberInput from './debounced/DebounceNumberInput';
import Label from '../../../../incase-domain/components/label/Label';

interface AppearAfterProps {
    appearAfter: number;
    highlightedElementChangeHandler: (animationValue: number) => void;
}
function AppearAfter(props: AppearAfterProps): ReactElement {
    const {appearAfter, highlightedElementChangeHandler} = props;
    const {t} = useTranslation();

    return (
        <div className="u-flex u-v-center u-h-between u-gap-2">
            <Label>{t('designSidepanel.appearAfter')}</Label>
            <DebouncedNumberInput value={appearAfter} onChange={(e) => highlightedElementChangeHandler(e)} step={0.5} min={0} />
        </div>
    );
}

export default AppearAfter;
